

import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import App from './App'
import router from './router'
import store from './store'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)
import { Lazyload } from 'vant';
Vue.use(Lazyload, {
lazyComponent: true,
});
Vue.config.productionTip = false
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


let projectObj={
'app.sxfoundation.com':{project:'shanxing',account:'西安市善行公益慈善基金会'},
'app.bangbangwang.cn':{project:'shanxing',account:'西安市善行公益慈善基金会'},
'inside.sxfoundation.com':{project:'shanxing',account:'西安市善行公益慈善基金会'},
'f.futuresmile.org.cn':{project:'smile',account:'微笑明天慈善基金会'},
'finside.futuresmile.org.cn':{project:'smile',account:'微笑明天慈善基金会'},
'web.scredcross.com':{project:'scredcross',account:'四川省红十字基金会'},
'web.zjfdp.com':{project:'zjfdp',account:'浙江省残疾人福利基金会'},
'xian.bee029.top':{project:'bee',account:'西安市小蜜蜂公益慈善基金会'},
'test.bee029.top':{project:'bee',account:'西安市小蜜蜂公益慈善基金会'},
'192.168.110.68:8081':{project:'shanxing',account:'微笑明天慈善基金会'},
}
Vue.prototype.project = projectObj[location.host]?projectObj[location.host].project:'shanxing'
Vue.prototype.officialAccount = projectObj[location.host]?projectObj[location.host].account:'西安市善行公益慈善基金会'
Vue.prototype.ossPath = 'https://cdn.sxfoundation.com'

import './plugin/index.js'

/*import * as filters from './filters'
Object.keys(filters).forEach(key => {
Vue.filter(key, filters[key])
})*/
import mixin from './mixin/index'
Vue.mixin(mixin)
window.stopPropagationFn = function (ev) {
ev.stopPropagation()
}

var _hmt = _hmt || [];
window._hmt = _hmt; 
(function () {
var hm = document.createElement("script");
hm.src = "https://hm.baidu.com/hm.js?d6c76573ea10ccf4a918827088ea7faf";
var s = document.getElementsByTagName("script")[0];
s.parentNode.insertBefore(hm, s);
})();
/* eslint-disable no-new */
new Vue({
router,
store,
render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js